import { applySnapshot, types } from 'mobx-state-tree';

declare global {
  interface Window {
    MSStream: string;
  }
}

const devices = {
  android: 'Android',
  winPhone: 'Windows Phone',
  iOS: 'iOS',
};

const UI = types
  .model({
    hideMobileHeader: true,
    isMobileScreen: false,
    deviceType: '',
    isKeyboardPopped: false,
    width: 0,
    height: 0,
  })
  .views((self) => ({
    get headerHeight() {
      const elem = document.getElementById('contentHeader');
      return elem?.offsetHeight || 0;
    },
    get formSpacing() {
      return self.isMobileScreen ? 2 : 3;
    },
  }))
  .actions((self) => ({
    // eslint-disable-next-line
    updateField: (field: string, value: any) => {
      applySnapshot(self, { ...self, [field]: value });
    },
    detectDeviceType: () => {
      const userAgent = navigator?.userAgent || navigator?.vendor;

      // Windows Phone must come first because its UA also contains 'Android'
      if (/windows phone/i.test(userAgent)) return (self.deviceType = devices.winPhone);

      if (/android/i.test(userAgent)) return (self.deviceType = devices.android);

      // iOS detection from: http://stackoverflow.com/a/9039885/177710

      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream)
        return (self.deviceType = devices.iOS);
    },
    isIOS: () => self.deviceType === devices.iOS,
    isAndroid: () => self.deviceType === devices.android || self.deviceType === devices.winPhone,
    setIsKeyboardPopped: (isKeyboardPopped: boolean) => {
      self.isKeyboardPopped = isKeyboardPopped;
    },
  }))
  .actions((self) => ({
    resetStore: () => {
      self.hideMobileHeader = true;
      self.isMobileScreen = false;
      self.deviceType = '';
      self.isKeyboardPopped = false;
      self.width = 0;
      self.height = 0;
      if (window.innerWidth <= 640 && !self.isMobileScreen) {
        self.updateField('isMobileScreen', true);
      } else if (window.innerWidth > 640 && self.isMobileScreen) {
        self.updateField('isMobileScreen', false);
      }

      if (window.innerHeight <= 500) {
        self.setIsKeyboardPopped(true);
      } else {
        self.setIsKeyboardPopped(false);
      }
    },
  }));

export default UI;
